module.exports = __webpack_public_path__ + "img/dia_dos_namorados.efa52bda.svg";